<template>
  <c-modal
    width="876"
    :value="true"
    :persistent="true"
    :hideCloseBtn="processing"
    @onClosed="onClosed"
  >
    <div class="heading-4 font-weight-medium">Gnosis Safe Multisig</div>
    <v-container class="pa-0 mt-8 gnosis-container">
      <v-row>
        <v-col cols="5" class="d-flex">
          <div>
            <tx-info class="flex-1" :info="vaultInfo" />
            <v-divider class="mt-5 mb-5"></v-divider>
            <div>
              This transaction requires the authorization of
              {{ gnosisWallet.metadata.threshold }} out of
              {{ gnosisWallet.metadata.owners.length }} owners.
            </div>
          </div>
        </v-col>
        <v-col cols="7" class="d-flex flex-column border-left-default">
          <div class="flex-1">
            <step-info />
            <select-signer
              v-if="step === 1"
              class="mt-5"
              :signerAddress="signerAddress"
              @setSignerAddress="setSignerAddress"
            />
            <connect-signer
              v-if="step === 2"
              class="mt-5"
              :signerAddress="signerAddress"
              :signerWallet="signerWallet"
              @setSignerWallet="setSignerWallet"
            />
            <confirm
              v-if="step === 3"
              class="mt-5"
              :signerWallet="signerWallet"
            />
            <after-signed class="mt-8" v-if="step === 4" />
          </div>
          <div class="d-flex align-center justify-space-between mt-10">
            <div>
              <div
                class="text-5 gray--text clickable"
                v-if="step > 1 && step < 4"
                @click="step = step - 1"
              >
                Back
              </div>
            </div>
            <div class="d-flex justify-end">
              <c-btn :disabled="btnDisabled" @click="next">{{ btnText }}</c-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </c-modal>
</template>

<script>
import { mapGetters } from "vuex";
import StepInfo from "./StepInfo";
import TxInfo from "./TxInfo";
import SelectSigner from "./SelectSigner";
import ConnectSigner from "./ConnectSigner";
import Confirm from "./Confirm";
import AfterSigned from "./AfterSigned";
export default {
  props: ["vaultInfo"],
  components: {
    TxInfo,
    StepInfo,
    SelectSigner,
    ConnectSigner,
    Confirm,
    AfterSigned,
  },
  computed: {
    ...mapGetters({
      gnosisWallet: "userWallets/gnosis/wallet",
    }),
    btnDisabled() {
      if (this.step === 1) {
        return !this.signerAddress;
      }
      if (this.step === 2) {
        return !this.signerWallet;
      }
    },
    btnText() {
      if (this.step === 3) {
        return "Approve Transaction";
      }
      return "Continue";
    },
  },
  data: () => ({
    step: 1,
    processing: false,
    signerAddress: null,
    signerWallet: null,
  }),
  methods: {
    onClosed() {
      this.$emit("cancel");
    },
    setSignerAddress(address) {
      this.signerAddress = address;
    },
    setSignerWallet(wallet, next) {
      this.signerWallet = wallet;
      if (next) {
        this.next();
      }
    },
    next() {
      this.step = this.step + 1;
      if (this.step === 5) {
        this.onClosed();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.border-left-default {
  border-left: 1px solid var(--lightgray);
}
</style>
